import * as Forms    from '../components/forms';
import * as User     from '../user';
import { compose }   from 'redux';
import { connect }   from 'react-redux';
import classnames    from 'classnames';
import Navbar        from '../components/navbar';
import React         from 'react';
import SaveOnChange  from '../components/save_on_change';
import SwitchControl from '../components/switch_control';


export default connect(
  state => ({
    notifications: User.getNotificationSettings(state)
  }),
  dispatch => ({
    save: compose(dispatch, User.updateProfile)
  })
)(NotificationsPage);


export function NotificationsPage({ notifications, save }) {
  return (
    <React.Fragment>
      <Navbar title="Notifications"/>
      <div className="page-content">
        <NewMessages notifications={notifications} save={save}/>
        <NotifyMeOf notifications={notifications} save={save}/>
        <EmailNotifications notifications={notifications} save={save}/>
      </div>
    </React.Fragment>
  );
}

function NewMessages({ notifications, save }) {
  async function saveAllMessagesOption({ target }) {
    const { value }        = target;
    const newNotifications = {
      allMessages: value === 'all'
    };
    await save({ notifications: newNotifications });
  }

  const className = classnames('list', 'media-list', 'block');

  return (
    <SaveOnChange className={className} save={saveAllMessagesOption}>
      {onChange => (
        <ul>
          <li className="list-group-title">New Messages</li>
          <Forms.Radio
            label="Only my conversations"
            name="notification.message"
            value="only"
            onChange={onChange}
            subtitle="Only notify me about conversations I'm participating in or listed as the assisting team member"
            defaultChecked={!!notifications && !notifications.allMessages}
          />
          <Forms.Radio
            label="All customer messages"
            name="notification.message"
            value="all"
            onChange={onChange}
            subtitle="Notify me of all incoming messages"
            defaultChecked={!!notifications && !!notifications.allMessages}
          />
        </ul>
      )}
    </SaveOnChange>
  );
}


function NotifyMeOf({ notifications, save }) {
  return (
    <div className="list block">
      <ul>
        <li className="list-group-title">Notify me of...</li>
        <SwitchItem
          label="New leads"
          description="Notify me of incoming leads"
          checked={!!notifications && !!notifications.leads}
          save={value => save({ notifications: { leads: value  } })}/>
        <SwitchItem
          label="New reviews"
          description="Notify me of new reviews"
          checked={!!notifications && !!notifications.reviews}
          save={value => save({ notifications: { reviews: value } })}/>
        <SwitchItem
          label="Daily updates"
          description="Notify me of new reviews and customers who recommended my business"
          checked={!!notifications && !!notifications.dailyUpdates}
          save={value => save({ notifications: { dailyUpdates: value } })}/>
      </ul>
    </div>
  );
}


function EmailNotifications({ notifications, save }) {
  return (
    <div className="list block">
      <ul>
        <li className="list-group-title">Email Notifications</li>
        <SwitchItem
          label="Send me notifications via email"
          description="You will still receive desktop and mobile app notifications"
          checked={!!notifications && !!notifications.delivery && !!notifications.delivery.email}
          save={value => save({ notifications: { delivery: { email: value } } })}/>
      </ul>
    </div>
  );
}


function SwitchItem({ label, description, checked, save }) {
  return (
    <li className="item-content switch-item">
      <div className="item-inner">
        <div className="item-title">
          <span>{label}</span>
          <div className="item-footer">{description}</div>
        </div>
        <div className="item-after">
          <SwitchControl
            checked={checked}
            save={save}
          />
        </div>
      </div>
    </li>
  );
}
